import useStore from '../../../../../../hooks/useStore';
import { PlasseringAvEnhetIByggVertikalt } from '../../../../../../components/registering/utils/registerEnums';
import { getV2025Steps } from '../../../../utils/stepperUtils';
import { RegistrationCommonStep } from '../../../../../../utils/navigation';
import { useUser } from '../../../../../../hooks/useUser';
import { UserInput } from '../../../../../../types/registration/userInput';
import { detaljeringsstegDefault } from '../utils';

export const useDetaljeringFormData = () => {
  const store = useStore();
  const userInput = store.getState().register.userInput;
  const { user } = useUser();

  // If verticalPlacement is undefined, we consider it as OversteEtasje
  const isOversteEtasje = userInput.bygningsdetaljer.plasseringAvEnhetIByggVertikalt == null ||
  userInput.bygningsdetaljer.plasseringAvEnhetIByggVertikalt === PlasseringAvEnhetIByggVertikalt.OversteEtasje;

  const getNextStepFromUserInput = (userInput?: UserInput) => {
    const steps = getV2025Steps(user, userInput?.detaljeringssteg);
    const currentStepIndex = steps.findIndex((step) => step === RegistrationCommonStep.DETAIILING);

    return steps[currentStepIndex + 1];
  };

  return {
    defaultValues: userInput.detaljeringssteg ?? detaljeringsstegDefault,
    isOversteEtasje,
    getNextStepFromUserInput
  };
};
